import { AdminDashboard } from './admin/AdminDashboard';
import { PublicCatalog } from './viewer/PublicCatalog';

export function App() {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const isAdmin = parts.length === 0 || parts[0] === 'admin';

  if (!isAdmin) {
    if (parts[0] === 'catalog' && parts[1]) {
      return <PublicCatalog slug={parts[1]} />;
    }

    return <PublicCatalog slug={parts[0] ?? ''} />;
  }

  return <AdminDashboard />;
}
